// import { ToggleWF } from "../Workflows/FacilityBreakdownWorkFlowComponent"

import { Lock, Trash2 } from "react-bootstrap-icons"
import { ICONS } from "../../../../../../components/icons/GenericIconPicker"
import { ToggleWF } from "../Workflows/FacilityBreakdownWorkFlowComponent"

export const ToDoListMainContainer = ({ res }) => {
    return (
        res.toDo && res.toDo.map(r =>
            <div className="bg-light text-dark rounded p-2 m-2" style={{ fontSize: '1rem' }}>
                <ToggleWF deleted={r.isDeleted} locked={r.isLocked} title={r.group}>
                    {r.lists.map(l => <ToDoListItemContainer list={l}>
                        {l.items.map(i => <ToDoListStatusContainer item={i} />)}
                    </ToDoListItemContainer>)}
                </ToggleWF>
            </div>
        )
    )
}
export const ToDoListItemContainer = ({ list, children }) => {
    return (<div className="ms-2">
        <TitleWrapper title={list.list} locked={list.locked} deleted={list.deleted} />
        {children}
    </div>)
}
export const ToDoListStatusContainer = ({ item }) => {
    const findProp = (prop, parse) => {
        const res = item.properties.find(p => p.property === prop)
        return res ? parse ? JSON.parse(res.value) : res.value : undefined
    }
    return (<div className="ms-2">
        <div className="d-flex px-2" style={{ background: findProp('COLOUR') }}>
            <div className="flex-grow-1">
                {item.isDeleted && <Trash2 />}
                {item.isDefault && <b><i>Default </i></b>}
                {findProp('REMOVE_ON_SELECTED', true) && <b><i>Closes List Item </i></b>}
                {item.item}
            </div>
            <div className="flex-shrink-1 d-flex">
                {findProp('SEVERITY') && <b><i>{findProp('SEVERITY')}</i></b>}
                {findProp('ICONS', true) && findProp('ICONS', true).map(icon => <div>{ICONS.find(f => f.name && f.name === icon).icon}</div>)}
            </div>
        </div>
    </div>)
}

const TitleWrapper = ({ deleted, locked, title }) => {
    return (<div className="flex-grow-1">
        {locked && <Lock />}
        {deleted && <Trash2 />}
        {title}
    </div>)
}